import Vue from 'vue'
import router from './views'
import Cover from 'vendors/cover/cover.js'
import 'vendors/cover/cover.css'

import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(Cover)
Vue.use(VueResource);
Vue.use(VueCookies);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    siderOpen: false
  },
  router,
  render (h) {
    return (<router-view></router-view>)
  }
})



// WEBPACK FOOTER //
// ./src/main.js